import cls from 'classnames';

import useStyles from './styles';
import { FaqMinimalProps } from './types';
import FaqItem from './FaqItem';

function FaqMinimal({
  items,
  className,
  titleTag = 'h2',
  headingTag = 'h3',
  descriptionTag = 'div',
  title = 'FAQ',
}: FaqMinimalProps) {
  const classes = useStyles();
  const TitleTag = titleTag;

  return (
    <section className={cls(classes.root, className)}>
      <TitleTag className={classes.title}>{title}</TitleTag>
      <ul className={cls(classes.lst)}>
        {items.map((item, i) => (
          <FaqItem
            initialExpansion={i === 0}
            headingTag={headingTag}
            descriptionTag={descriptionTag}
            key={`faqm-${i}`}
            title={item.title}
            description={item.description}
          />
        ))}
      </ul>
    </section>
  );
}

export default FaqMinimal;
